import { useEffect, useRef } from 'react';

// Space would type into these, so it's left to them
const TYPES_TEXT = 'textarea, select, [contenteditable="true"], input:not([type="checkbox"]):not([type="range"])';

/**
 * Space plays and pauses, as in any player. Taken from a focused button too, which would otherwise press it.
 * `toggle` is read through a ref so the listener is bound once; pass null while there's nothing to play.
 */
const useSpaceToPlay = (toggle) => {
  const toggleRef = useRef(toggle);
  toggleRef.current = toggle;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.code !== 'Space' || e.repeat || e.target.closest?.(TYPES_TEXT)) return;
      e.preventDefault();
      toggleRef.current?.();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
};

export default useSpaceToPlay;
